// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__3vsTt","topBottomGutter":"Layout_topBottomGutter__RjJeK"};